import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ecd2fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import { toRefs, ref, onMounted } from "vue"

enum State {
  IDLE,
  START,
  CLICK,
  FADE
}

interface Props {
  el: HTMLElement,
  repeat: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Example',
  props: {
    el: null,
    repeat: null
  },
  emits: ['actionListener'],
  setup(__props: any, { emit }) {

const props = __props as {
  el: HTMLElement,
  repeat: number
};

_useCssVars(_ctx => ({
  "bd6276f2": (top.value),
  "eef3f9d6": (left.value)
}))



const { el, repeat } = toRefs(props);



const root = ref();

const top = ref('0px');
const left = ref('0px');
const repeatCount = ref(0);

const state = ref<State>(State.IDLE);

const start = async() => {
  state.value = State.START;
  top.value = (el.value.clientWidth / 2) + 'px';
  left.value = (el.value.clientHeight / 2) + 'px';
}
start();

onMounted(() => {
  repeatCount.value = props.repeat;
  root.value.addEventListener('animationend', function() {
    if (state.value == State.CLICK) {
      if (repeatCount.value == 0) {
        emit('actionListener');
      } else {
        state.value = State.IDLE;
        repeatCount.value--;
        setTimeout(() => {
          state.value = State.START;
        }, 4000);
      }
      state.value = State.FADE;
    }
    else if (state.value == State.START) {
      state.value = State.CLICK;
    }
  });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["root", {'move': state.value == State.START, 'click': state.value == State.CLICK, 'fade': state.value == State.FADE}]),
    ref_key: "root",
    ref: root
  }, [
    (state.value == State.START || state.value == State.FADE)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          alt: "",
          src: require('@/assets/img/pointer.png')
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (state.value == State.CLICK)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          alt: "",
          src: require('@/assets/img/pointer_click.png')
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})